const googlePlay =
  "https://play.google.com/store/apps/details?id=com.vhandicap.vphone";
const appStore = "https://apps.apple.com/vn/app/wghn/id1590376779?l=vi";

const copyright = "https://vbooking.golf/";

export default { googlePlay, appStore, copyright };
